import { Tag } from "antd";

function AppTag(props) {
  let colorPresets = {
    open: "#3363C1",
    success: "#12CB5C",
    warning: "#F9983F",
    purple: "#925CA2",
    error: "#BB1766",
    yellow: "#C1A008",
  };
  let color = colorPresets[props?.color] || "success";

  // Function to lighten a hex color
  const lightenColor = (hex, percent) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const r = (num >> 16) + Math.round((255 - (num >> 16)) * percent);
    const g =
      ((num >> 8) & 0x00ff) +
      Math.round((255 - ((num >> 8) & 0x00ff)) * percent);
    const b = (num & 0x0000ff) + Math.round((255 - (num & 0x0000ff)) * percent);
    return `rgb(${r},${g},${b})`;
  };

  const lightBg = lightenColor(color, 0.85);

  return (
    <Tag
      className="px-3 py-2 fs-5"
      style={{
        backgroundColor: lightBg,
        color: color,
        fontWeight: 500,
        textTransform: "capitalize",
      }}
      //   color={color}
      bordered={false}
    >
      {props.children}
    </Tag>
  );
}

export default AppTag;
